import { Link } from "react-router-dom";
import React, { useRef, useState, useContext } from "react";
import useIntersectionObserver from "../../../hooks/useIntersectionObserver";
import "../../../style.css";

const Intro = ({ dynamicContent }) => {
  const sectionRef = useRef(null);
  const [contentLoaded, setContentLoaded] = useState(false);

  const handleIntersection = () => {
    setContentLoaded(true);
  };

  const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

  return (
    <div
      ref={sectionRef}
      className={`loading-container${
        contentLoaded ? "" : " loading-spinner-container"
      }`}
    >
      {contentLoaded ? (
        <section
          className={`intro${isVisible ? " fade-in-observer" : ""}`}
          id="intro"
        >
          <div className="intro-content section-content">
            <p className="section-subtitle">{dynamicContent.ProductName}</p>
            <h2 className="h3 section-title">{dynamicContent.IntroTitle}</h2>
            <p className="section-text">{dynamicContent.IntroDescription}</p>
          </div>
        </section>
      ) : (
        <div className="observer_spinner"></div>
      )}
    </div>
  );
};

export default Intro;
